import { Issue } from "@/_models/issue.interface";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-issue-task-card",
    standalone: true,
    imports: [SharedComponentsModule, CombinedTaskCardMobileComponent],
    templateUrl: "./issue-task-card.component.html",
    styleUrls: [
        "./issue-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class IssueTaskCardComponent implements OnInit {
    @Input() issue: Issue;
    @Input() showEdit: boolean = false;

    ngOnInit() {}
}
